import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ProductVariant } from '../../models/product.model';

@Component({
  selector: 'app-variant-badge',
  template: `
    @if (variant() !== 'non-foil') {
      <span class="variant-badge" [attr.data-variant]="variant()">
        <ng-content />
      </span>
    }
  `,
  styleUrl: './variant-badge.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class VariantBadgeComponent {
  variant = input.required<ProductVariant>();
}
